export default function ToggleButton({ viewMode, setViewMode, options = [] }) {
    return (
        <div className="flex bg-gray-100 border border-gray-300 rounded-md p-0.5">
            {options.map(({ key, label, Icon }) => (
                <button
                    key={key}
                    type="button"
                    onClick={() => setViewMode(key)}
                    className={[
                        "flex items-center gap-1.5 px-3 py-1 rounded text-[13px] font-semibold cursor-pointer transition-colors",
                        viewMode === key ? "bg-white text-[#063A6C] shadow-sm" : "text-gray-500 hover:text-gray-700"
                    ].join(" ")}
                >
                    {Icon && <Icon size={13} />}
                    {label}
                </button>
            ))}
        </div>
    );
}